export default "__VITE_ASSET__8uKBKs1o__"